import logo from './logo.svg';
import './App.css';
import {BrowserRouter,Routes,Route } from 'react-router-dom';
import ShootGame from './ShootGame';
import PuzzleGame from './PuzzleGame';
import Tictactoe from './Tictactoe';
import SnakeL from './SnakeL';
import Paint from './Paint';
import Suduko from './Suduko';
import Pimg from './Pimg';
import Organ from './Organ';
import BoxBuilding from './BoxBuilding';
import Birds from './Birds';
import SearchAnimals from './SearchAnimals';
import Others from './Others';
import OtherBox from './OtherBox';
import Slate from './Slate';
import Addition from './Addition';
import Subtractions from './Subtractions';
import Nav from './Nav';
import Home from './Home';
import Multiplications from './Multiplications';
import StoryTeller from './StoryTeller';
import Spell from './Spell';
import Paintt from './Paintt';
import Translator from './Translator';
import Matching from './Matching';
import ImageCard from './ImageCard';
import WordCard from './WordCard';
import VoiceCalc from './VoiceCalc';
import Colors from './Colors';
import Time from './Time';
import Time2 from './Time2';
import Fruits from './Fruits';
import VoiceGames from './VoiceGames';
import GuessTheNumber from './GuessTheNumber';
import ColorPicker from './ColorPicker';
import WordReversal from './WordReversal';
import SimonSays from './SimonSays';
import MathQuiz from './MathQuiz';
import Mind from './Mind';
import ListenSpelling from './ListenSpelling';
import ListenWeek from './ListenWeek';
import ListenMonths from './ListenMonths';
import ListenColors from './ListenColors';
import ListenVegetables from './ListenVegetables';
import Emotions from './Emotions';
import Maze from './Maze';
import Pingpong from './Pingpong';
import Vegetables from './Vegetables';
import WordBuild from './WordBuild';
import SpellBee from './SpellBee';
import Seasons from './Seasons';
import ReadText from './ReadText';
import Studies from './Studies';
import SRead from './SRead';
import ControlStudy from './ControlStudy';
import DisplayStudy from './DisplayStudy';
import ImageStudy from './ImageStudy';
import ImageDisplay from './ImageDisplay';
import AlphaNum from './AlphaNum';
import AlphaNum1 from './AlphaNum1';
import Alphabets from './Alphabets';
import MultiplicationTable from './MulitplicationTable';
import MathApp from './MathApp';
import SnakeGame from './SnakeGame';
import SlideRiver from './SlideRiver';
import SlidesRiver from './SlidesRiver';
import River5India from './River5India';
import Calculator from './Calculator';
import NumberSorter from './NumberSorter';
import Animals from './Animals';
import Birds25 from './Birds25';
import Fish from './Fish';
import AEquationSolver from './AEquationSolver';
import NationalSymbols from './NationalSymbols';
import ElectronicsInfo from './ElectronicsInfo';
import CountryInfo from './CountryInfo';
import WaterBodiesInfo from './WaterBodiesInfo';
import TechInfo from './TechInfo';
import BodyPartsInfo from './BodyPartsInfo';
import GeneralQuiz from './GeneralQuiz';
import WorldRecords from './WorldRecords';
import Sentences from './Sentences';
import Words from './Words';
import OddManOut from './OddManOut';
import Reasoning from './Reasoning';
import FactDisplay from './FactDisplay';
import Maths from './Maths';
import Paint1 from './Paint1';
import English from './English';
import CBSE3 from './CBSE3';
import Riddle from './Riddle';
import EnglishCBSE3 from './EnglishCBSE3';
import SelfAwarness from './SelfAwareness';
import InsightsDashboard from './InsightsDashboard';
import DailyReminder from './DailyReminder';
import EmotionWheel from './EmotionWheel';
import GratitudeLog from './GratitudeLog';
import ThoughtJournal from './ThoughtJournal';
import MoodTracker from './MoodTracker';
import SelfIntroduce from './SelfIntroduce';
import Story from './Story';
import Handwriting from './Handwriting';
import FestivalsApp from './FestivalsApp';
import USFestivalApp from './USFestivalApp';
import ScienceBasics from './ScienceBasics';
import UKFestivalApp from './UKFestivalApp';
import StocksBasics from './StocksBasics';
import Money from './Money';
import NatureBasics from './NatureBasics';
import WhatHelps from './WhatHelps';
import Inventions from './Inventions';
import LessonsHindi from './LessonsHindi';
import LessonList from './LessonList';
import HumanBody from './HumanBody';
import LifeSkills from './LifeSkills';
import ThingsToAvoid from './ThingsToAvoid';
import Circuits from './Circuits';
import EmojiSudoku from './EmojiSuduko';
import MemoryGame from './MemoryGame';
import ColorMatch from './ColorMatch';
import ShapeSorter from './ShapeSorter';
import MathQuizz from './MathQuizz';
import TriviaQuiz from './TriviaQuiz';
import MathBingo from './MathBingo';
import QuizWheel from './QuizWheel';
import EmojiQuiz from './EmojiQuiz';
import PuzzleSlider from './PuzzleSlider';
import AnimalSound from './AnimalSound';
import MathLadder from './MathLadder';
import EmojiTicTacToe from './EmojiTicTacToe';
import EmojiConnect from './EmojiConnect';
import WordBuilder from './WordBuilder';
import GeographyExplorer from './GeographyExplorer';
import WordBuilder1 from './WordBuilder1';
import SynonymMatch from './SynonymMatch';
import EmojiBoardRace from './EmojiBoardRace';
import Maze1 from './Maze1';
import ChalkSlate from './ChalkSlate';
import ScienceLab from './ScienceLab';
import Crossword from './Crossword';
import WordBingo from './WordBingo';
import AntonymMatch from './AntonymMatch';

function App() {
  return (
    <div className="App">
      <Nav/>
    <Routes>
      
      
      <Route path="/" element={<Others />}/>
        
        <Route path="/SearchAnimals" element={<SearchAnimals/>}/>
        <Route path="/BoxBuilding" element={<BoxBuilding/>}/>
        <Route path="/Others" element={<Others/>}/>
        <Route path="/Nav" element={<Nav/>}/>
        <Route path='/Organ' element={<Organ/>}/>
        <Route path="/Pimg" exact element={<Pimg/>}/>
        <Route path="/Suduko" exact element={<Suduko/>}/>
        <Route path="/VoiceGames" exact element={<VoiceGames/>}/>
        <Route path="/GuessTheNumber" exact element={<GuessTheNumber/>}/>
        <Route path="/ColorPicker" exact element={<ColorPicker/>}/>
        <Route path="/WordReversal" exact element={<WordReversal/>}/>
        <Route path="/SimonSays" exact element={<SimonSays/>}/>
        <Route path="/MathQuiz" exact element={<MathQuiz/>}/>
        <Route path="/Mind" exact element={<Mind/>}/>

        <Route path="/Subtractions" exact element={<Subtractions/>}/>
        <Route path="/Multiplications" exact element={<Multiplications/>}/>

           <Route path="/LessonsHindi" exact element={<LessonsHindi/>}/>
          <Route path="/LessonList" exact element={<LessonList/>}/>

                    <Route path="/EmojiSuduko" exact element={<EmojiSudoku/>}/>

          <Route path="/MemoryGame" exact element={<MemoryGame/>}/>

           <Route path="/ColorMatch" exact element={<ColorMatch/>}/>
          <Route path="/ShapeSorter" exact element={<ShapeSorter/>}/>
          <Route path="/MathQuizz" exact element={<MathQuizz/>}/>

        <Route path="/MathLadder" exact element={<MathLadder/>}/>
       <Route path="/EmojiTicTacToe" exact element={<EmojiTicTacToe/>}/>

       <Route path="/EmojiConnect" exact element={<EmojiConnect/>}/>
       <Route path="/WordBuilder1" exact element={<WordBuilder1/>}/>

      <Route path="/SynonymMatch" exact element={<SynonymMatch/>}/>
    <Route path="/EmojiBoardRace" exact element={<EmojiBoardRace/>}/>

        <Route path="/Maze1" exact element={<Maze1/>}/>

                <Route path="/ChalkSlate" exact element={<ChalkSlate/>}/>

        <Route path="/ScienceLab" exact element={<ScienceLab/>}/>

      <Route path="/Crossword" exact element={<Crossword/>}/>
            <Route path="/WordBingo" exact element={<WordBingo/>}/>

   <Route path="/AntonymMatch" exact element={<AntonymMatch/>}/>










       <Route path="/WordBuilder" exact element={<WordBuilder/>}/>
              <Route path="/GeographyExplorer" exact element={<GeographyExplorer/>}/>



        



          <Route path="/TriviaQuiz" exact element={<TriviaQuiz/>}/>
        <Route path="/MathBingo" exact element={<MathBingo/>}/>
         <Route path="/QuizWheel" exact element={<QuizWheel/>}/>
        <Route path="/EmojiQuiz" exact element={<EmojiQuiz/>}/>
      <Route path="/PuzzleSlider" exact element={<PuzzleSlider/>}/>
   <Route path="/AnimalSound" exact element={<AnimalSound/>}/>











        
        <Route path="/SelfIntroduce" exact element={<SelfIntroduce/>}/>

        <Route path="/Story" exact element={<Story/>}/>
        <Route path="/ScienceBasics" exact element={<ScienceBasics/>}/>
        <Route path="/StocksBasics" exact element={<StocksBasics/>}/>
         <Route path="/Money" exact element={<Money/>}/>
          <Route path="/NatureBasics" exact element={<NatureBasics/>}/>
          <Route path="/WhatHelps" exact element={<WhatHelps/>}/>
          <Route path="/Inventions" exact element={<Inventions/>}/>

          <Route path="/Circuits" exact element={<Circuits/>}/>



          <Route path="/HumanBody" exact element={<HumanBody/>}/>
          <Route path="/LifeSkills" exact element={<LifeSkills/>}/>
          <Route path="/ThingsToAvoid" exact element={<ThingsToAvoid/>}/>



        <Route path="/FestivalsApp" exact element={<FestivalsApp/>}/>
        <Route path="/USFestivalsApp" exact element={<USFestivalApp/>}/>
        <Route path="/UKFestivalsApp" exact element={<UKFestivalApp/>}/>



        <Route path="/Handwriting" exact element={<Handwriting/>}/>

        <Route path="/Paint" exact element={<Paint/>}/>
        <Route path="/Fruits" exact element={<Fruits/>}/>
        <Route path="/StoryTeller" exact element={<StoryTeller/>}/>
        <Route path="/VoiceCalc" exact element={<VoiceCalc/>}/>

        <Route path="/Translator" exact element={<Translator/>}/>
        <Route path="/Time2" exact element={<Time2/>}/>

        <Route path="/Spell" exact element={<Spell/>}/>
        <Route path="/Time" exact element={<Time/>}/>
        <Route path="/Paintt" exact element={<Paintt/>}/>

        <Route path="/Colors" exact element={<Colors/>}/>

        <Route path="/SnakeL" exact element={<SnakeL/>}/>

        <Route path="/Matching" exact element={<Matching/>}/>
        <Route path="/ImageCard" exact element={<ImageCard/>}/>
        <Route path="/WordCard" exact element={<WordCard/>}/>
        <Route path="/Tictactoe" exact element={<Tictactoe/>}/>
        <Route path="/Addition" exact element={<Addition/>}/>

        <Route path="/PuzzleGame" exact element={<PuzzleGame/>}/>

        <Route path="/ShootGame" exact element={<ShootGame/>}/>
        <Route path="/OtherBox" exact element={<OtherBox/>}/>
        <Route path="/Slate" exact element={<Slate/>}/>
        <Route path="/ListenSpelling" exact element={<ListenSpelling/>}/>
        <Route path="/ListenWeek" exact element={<ListenWeek/>}/>
        <Route path="/ListenMonths" exact element={<ListenMonths/>}/>
        <Route path="/ListenColors" exact element={<ListenColors/>}/>
        <Route path="/ListenVegetables" exact element={<ListenVegetables/>}/>
        <Route path="/Emotions" exact element={<Emotions/>}/>
        <Route path="/Maze" exact element={<Maze/>}/>
        <Route path="/Pingpong" exact element={<Pingpong/>}/>

        <Route path="/MathApp" exact element={<MathApp/>}/>
        <Route path="/Calculator" exact element={<Calculator/>}/>
        <Route path="/NumberSorter" exact element={<NumberSorter/>}/>
        <Route path="/Animals" exact element={<Animals/>}/>
        <Route path="/Birds25" exact element={<Birds25/>}/>
        <Route path="/Fish" exact element={<Fish/>}/>
        <Route path="/AEquationSolver" exact element={<AEquationSolver/>}/>
        <Route path="/NationalSymbols" exact element={<NationalSymbols/>}/>
        <Route path="/ElectronicsInfo" exact element={<ElectronicsInfo/>}/>
        <Route path="/CountryInfo" exact element={<CountryInfo/>}/>
        <Route path="/WaterBodiesInfo" exact element={<WaterBodiesInfo/>}/>

        <Route path="/SlideRiver" exact element={<SlideRiver/>}/>
        <Route path="/River5India" exact element={<River5India/>}/>
        <Route path="/SlidesRiver" exact element={<SlidesRiver/>}/>
        <Route path="/TechInfo" exact element={<TechInfo/>}/>
        <Route path="/BodyPartsInfo" exact element={<BodyPartsInfo/>}/>
        <Route path="/GeneralQuiz" exact element={<GeneralQuiz/>}/>

        <Route path="/Riddle" exact element={<Riddle/>}/>

        <Route path="/SelfAwareness" exact element={<SelfAwarness/>}/>
        <Route path="/InsightsDashboard" exact element={<InsightsDashboard/>}/>
        <Route path="/DailyReminder" exact element={<DailyReminder/>}/>
        <Route path="/EmotionWheel" exact element={<EmotionWheel/>}/>
        <Route path="/GratitudeLog" exact element={<GratitudeLog/>}/>
        <Route path="/ThoughtJournal" exact element={<ThoughtJournal/>}/>
        <Route path="/MoodTracker" exact element={<MoodTracker/>}/>

        <Route path="/EnglishCBSE3" exact element={<EnglishCBSE3/>}/>

        <Route path="/WorldRecords" exact element={<WorldRecords/>}/>
        <Route path="/Sentences" exact element={<Sentences/>}/>
        <Route path="/Words" exact element={<Words/>}/>
        <Route path="/OddManOut" exact element={<OddManOut/>}/>
        <Route path="/Reasoning" exact element={<Reasoning/>}/>
        <Route path="/FactDisplay" exact element={<FactDisplay/>}/>

        <Route path="/CBSE3" exact element={<CBSE3/>}/>

        <Route path="/Maths" exact element={<Maths/>}/>
        <Route path="/English" exact element={<English/>}/>
        <Route path="/Paint1" exact element={<Paint1/>}/>

        <Route path="/SnakeGame" exact element={<SnakeGame/>}/>

        <Route path="/AlphaNum" exact element={<AlphaNum/>}/>
        <Route path="/AlphaNum1" exact element={<AlphaNum1/>}/>
        <Route path="/Alphabets" exact element={<Alphabets/>}/>
        <Route path="/MultiplicationTable" exact element={<MultiplicationTable/>}/>

        <Route path="/Vegetables" exact element={<Vegetables/>}/>
        <Route path="/WordBuild" exact element={<WordBuild/>}/>
        <Route path="/SpellBee" exact element={<SpellBee/>}/>
        <Route path="/Seasons" exact element={<Seasons/>}/>
        <Route path="/ReadText" exact element={<ReadText/>}/>
        <Route path="/Studies" exact element={<Studies/>}/>
        <Route path="/SRead" exact element={<SRead/>}/>
        <Route path="/ControlStudy" exact element={<ControlStudy/>}/>
        <Route path="/DisplayStudy" exact element={<DisplayStudy/>}/>
        <Route path="/ImageStudy" exact element={<ImageStudy/>}/>
        <Route path="/ImageDisplay" exact element={<ImageDisplay/>}/>
     

    </Routes>
    
        
     
     
    </div>
  );
}

export default App;
